import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseComponent } from '../../shared';


/**
 * Component to notification threshold settings in Plan Settings page.
 */
@Component({
	selector: 'tsp-notification-threshold',
	imports: [
		FormsModule,
		ReactiveFormsModule
	],
	templateUrl: './notification-threshold.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class NotificationThresholdComponent extends BaseComponent {

	threshold = model<number>(0);
	isReadonly = input<boolean>(false);

	readonly THRESHOLD_LIST = [1, 2, 3, 4, 5];
}
